import { render, staticRenderFns } from "./LeaEditTableColumn.vue?vue&type=template&id=409e5772&"
import script from "./LeaEditTableColumn.vue?vue&type=script&lang=js&"
export * from "./LeaEditTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./LeaEditTableColumn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports